const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPendingStep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 56,
    viewBox: "0 0 400 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    y1: 27,
    x2: 16,
    y2: 27,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 28.0007L42.6666 30.6673L48 25.334M33.1332 23.4941C32.9386 22.6175 32.9685 21.7059 33.2201 20.8439C33.4717 19.9819 33.9369 19.1974 34.5725 18.5631C35.2081 17.9288 35.9936 17.4652 36.8562 17.2154C37.7187 16.9656 38.6303 16.9377 39.5066 17.1341C39.9888 16.3798 40.6532 15.7591 41.4385 15.3292C42.2238 14.8992 43.1046 14.6738 43.9999 14.6738C44.8952 14.6738 45.776 14.8992 46.5613 15.3292C47.3466 15.7591 48.0109 16.3798 48.4932 17.1341C49.3708 16.9368 50.284 16.9647 51.1479 17.2151C52.0118 17.4655 52.7983 17.9303 53.4344 18.5663C54.0704 19.2023 54.5352 19.9889 54.7856 20.8528C55.036 21.7167 55.0639 22.6299 54.8666 23.5074C55.6208 23.9897 56.2415 24.6541 56.6715 25.4394C57.1015 26.2246 57.3268 27.1055 57.3268 28.0008C57.3268 28.896 57.1015 29.7769 56.6715 30.5622C56.2415 31.3474 55.6208 32.0118 54.8666 32.4941C55.063 33.3703 55.035 34.282 54.7852 35.1445C54.5354 36.007 54.0719 36.7925 53.4376 37.4282C52.8033 38.0638 52.0188 38.529 51.1568 38.7806C50.2948 39.0322 49.3832 39.0621 48.5066 38.8674C48.0249 39.6246 47.36 40.248 46.5734 40.6799C45.7868 41.1118 44.9039 41.3382 44.0066 41.3382C43.1092 41.3382 42.2263 41.1118 41.4397 40.6799C40.6531 40.248 39.9882 39.6246 39.5066 38.8674C38.6303 39.0639 37.7187 39.0359 36.8562 38.7861C35.9936 38.5363 35.2081 38.0728 34.5725 37.4385C33.9369 36.8042 33.4717 36.0197 33.2201 35.1577C32.9685 34.2957 32.9386 33.3841 33.1332 32.5074C32.3732 32.0264 31.7471 31.361 31.3133 30.5731C30.8795 29.7851 30.652 28.9003 30.652 28.0008C30.652 27.1013 30.8795 26.2164 31.3133 25.4285C31.7471 24.6405 32.3732 23.9751 33.1332 23.4941Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 27,
    x2: 172,
    y2: 27,
    stroke: "#75A9FC",
    style: {
      stroke: "#75A9FC",
      stroke: "color(display-p3 0.4605 0.6612 0.9872)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#5A95F6",
    style: {
      fill: "#5A95F6",
      fill: "color(display-p3 0.3529 0.5843 0.9647)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.667 40.9739C199.072 41.2079 199.532 41.3311 200 41.3311C200.468 41.3311 200.928 41.2079 201.333 40.9739L210.667 35.6405C211.072 35.4067 211.408 35.0705 211.642 34.6656C211.876 34.2608 212 33.8015 212 33.3339V22.6672C212 22.1996 211.876 21.7403 211.642 21.3354C211.408 20.9305 211.072 20.5943 210.667 20.3605L201.333 15.0272C200.928 14.7931 200.468 14.6699 200 14.6699C199.532 14.6699 199.072 14.7931 198.667 15.0272L189.333 20.3605C188.928 20.5943 188.592 20.9305 188.358 21.3354C188.124 21.7403 188 22.1996 188 22.6672V33.3339C188 33.8015 188.124 34.2608 188.358 34.6656C188.592 35.0705 188.928 35.4067 189.333 35.6405L198.667 40.9739Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 41.3333V28",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.387 21.334L200 28.0007L211.613 21.334",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 17.6934L206 24.56",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 27,
    x2: 328,
    y2: 27,
    stroke: "#75A9FC",
    style: {
      stroke: "#75A9FC",
      stroke: "color(display-p3 0.4605 0.6612 0.9872)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#5A95F6",
    style: {
      fill: "#5A95F6",
      fill: "color(display-p3 0.3529 0.5843 0.9647)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.667 39.9993C367.244 39.9993 369.333 37.91 369.333 35.3327C369.333 32.7554 367.244 30.666 364.667 30.666C362.089 30.666 360 32.7554 360 35.3327C360 37.91 362.089 39.9993 364.667 39.9993Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.334 39.9993C349.911 39.9993 352 37.91 352 35.3327C352 32.7554 349.911 30.666 347.334 30.666C344.756 30.666 342.667 32.7554 342.667 35.3327C342.667 37.91 344.756 39.9993 347.334 39.9993Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 20.0007C360.737 20.0007 361.334 19.4037 361.334 18.6673C361.334 17.9309 360.737 17.334 360 17.334C359.264 17.334 358.667 17.9309 358.667 18.6673C358.667 19.4037 359.264 20.0007 360 20.0007Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 35.3327V30.666L352 26.666L357.333 22.666L360 26.666H362.667",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendingStep);
export default __webpack_public_path__ + "static/media/icon_pending_step.86e0574271e746c2ea2fdbb691d19bbf.svg";
export { ForwardRef as ReactComponent };